import { resolverValor } from '../motor/parser'
import { normalizarBase64Imagen } from '../imagenes/base64.js'

function buscarInicioRun(xmlAntesDelPlaceholder) {
  const regex = /<w:r(?:\s[^>]*)?>/g
  let ultimoMatch = null
  let match

  while ((match = regex.exec(xmlAntesDelPlaceholder)) !== null) {
    ultimoMatch = match
  }

  return ultimoMatch ? ultimoMatch.index : -1
}

function construirRunImagen({ cx, cy, relsIndex, rId, imageName }) {
  return `
    <w:r>
      <w:drawing>
        <wp:inline
          distT="0"
          distB="0"
          distL="0"
          distR="0"
          xmlns:wp="http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing"
          xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main"
          xmlns:pic="http://schemas.openxmlformats.org/drawingml/2006/picture"
          xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">
          <wp:extent cx="${cx}" cy="${cy}"/>
          <wp:effectExtent l="0" t="0" r="0" b="0"/>
          <wp:docPr id="${relsIndex}" name="Picture ${relsIndex}"/>
          <wp:cNvGraphicFramePr>
            <a:graphicFrameLocks noChangeAspect="1"/>
          </wp:cNvGraphicFramePr>
          <a:graphic>
            <a:graphicData uri="http://schemas.openxmlformats.org/drawingml/2006/picture">
              <pic:pic>
                <pic:nvPicPr>
                  <pic:cNvPr id="${relsIndex}" name="${imageName}"/>
                  <pic:cNvPicPr/>
                </pic:nvPicPr>
                <pic:blipFill>
                  <a:blip r:embed="${rId}"/>
                  <a:stretch>
                    <a:fillRect/>
                  </a:stretch>
                </pic:blipFill>
                <pic:spPr>
                  <a:xfrm>
                    <a:off x="0" y="0"/>
                    <a:ext cx="${cx}" cy="${cy}"/>
                  </a:xfrm>
                  <a:prstGeom prst="rect">
                    <a:avLst/>
                  </a:prstGeom>
                </pic:spPr>
              </pic:pic>
            </a:graphicData>
          </a:graphic>
        </wp:inline>
      </w:drawing>
    </w:r>
  `.trim()
}

export function resolverImagenes(xml, datos, zip, xmlFileName, errors = []) {
  // relsPath es la relación entre los xml
  // Ejemplo: xmlFileName = 'document.xml', 'header1.xml', 'footer1.xml'
  const relsPath = `word/_rels/${xmlFileName}.rels`

  // Si no existe, crear estructura básica
  let relsXml = zip.file(relsPath)
    ? zip.file(relsPath).asText()
    : '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
      '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"></Relationships>'

  // calcular el índice inicial (el máximo Id existente rIdN)
  const usedRels = [...relsXml.matchAll(/Id="rId(\d+)"/g)].map((m) => parseInt(m[1], 10))
  let relsIndex = usedRels.length ? Math.max(...usedRels) : 0

  const placeholderRegex = /\$\{i:([^}]+)\}/g
  let resultado = ''
  let lastIndex = 0

  while (true) {
    const phMatch = placeholderRegex.exec(xml)
    if (!phMatch) break

    const placeholderStart = phMatch.index
    const placeholderEnd = placeholderRegex.lastIndex

    // Buscar inicio del <w:r> más cercano hacia atrás
    const antesPlaceholder = xml.slice(0, placeholderStart)
    const startWR = buscarInicioRun(antesPlaceholder)
    if (startWR === -1) continue

    // Buscar cierre del </w:r> más cercano hacia adelante
    const despuesPlaceholder = xml.slice(placeholderEnd)
    const endWRRel = despuesPlaceholder.indexOf('</w:r>')
    if (endWRRel === -1) continue
    const endWR = placeholderEnd + endWRRel + '</w:r>'.length

    // Extraemos info del placeholder
    let [path, size] = phMatch[1].split(',').map((s) => s.trim())
    const base64 = resolverValor(datos, path)
    const imagen = normalizarBase64Imagen(base64)
    if (!imagen) {
      errors.push({
        code: base64 ? 'image_invalid' : 'image_missing',
        message: base64
          ? 'La expresión i: no contiene una imagen base64 válida'
          : 'La expresión i: no devolvió contenido',
        detail: { path, xmlFileName },
      })
      resultado += xml.slice(lastIndex, startWR) + '<w:r></w:r>'
      lastIndex = endWR
      continue
    }

    relsIndex++
    const rId = 'rId' + relsIndex
    const imageName = `image${relsIndex}.${imagen.extension}`

    // Guardar imagen en la carpeta media
    zip.file(`word/media/${imageName}`, imagen.contenido, { base64: true })

    // Agregar relación al .rels de este XML específico
    const relXml = `<Relationship Id="${rId}" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="media/${imageName}"/>`
    relsXml = relsXml.replace('</Relationships>', `${relXml}\n</Relationships>`)

    // Tamaño en EMUs
    let cx = 2000000,
      cy = 500000
    if (size) {
      const [w, h] = size.split('x').map((n) => parseFloat(n) || 0)
      cx = Math.round(w * 9525)
      cy = Math.round(h * 9525)
    }

    const drawingRun = construirRunImagen({ cx, cy, relsIndex, rId, imageName })

    resultado += xml.slice(lastIndex, startWR) + drawingRun
    lastIndex = endWR
  }

  resultado += xml.slice(lastIndex)
  zip.file(relsPath, relsXml)

  return resultado
}
